import { Component, OnInit } from '@angular/core';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { VisualizadorLogService } from '../../../shared/services/apis/srv-log/visualizador-log.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ObterLogResponse } from '../../../shared/services/responses/srv-log/obter-log.response';
import { LogDadosSensiveisResponse } from '../../../shared/services/responses/srv-log/log-dados-sensiveis.response';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-visualizar-log-detalhe',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    RouterModule,
    MatTooltipModule,
    MatSelectModule,
    MatSlideToggleModule,
    TemPermissaoDirective,
  ],
  templateUrl: './visualizar-log-detalhe.component.html',
  styleUrl: './visualizar-log-detalhe.component.css',
})
export class VisualizarLogDetalheComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private visualizadorLogService: VisualizadorLogService,
    public dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_Logs;
  }

  public model: FormGroup;
  public modelDadosSensiveis: FormGroup;
  public idLog: number;
  public dadosRevelados: boolean = false;
  public _isLoading: boolean = false;
  public obterLogResponse: ObterLogResponse;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      idLog: [''],
      idEmpresa: [''],
      idUsuario: [''],
      tipo: [''],
      projetoOrigem: [''],
      funcaoOrigem: [''],
      datetimeInclusao: [''],
    });

    this.modelDadosSensiveis = this.formBuilder.group({
      parametroEntrada: [''],
      mensagem: [''],
    });

    this.dadosRevelados = false;

    if (this.activatedRoute.snapshot.paramMap.get('idLog')) {
      this.idLog = parseInt(this.activatedRoute.snapshot.paramMap.get('idLog') ?? '');
    }

    this.popularDadosLog();
  }

  popularDadosLog(): void {
    this._isLoading = true;
    this.visualizadorLogService.get(this.idLog).subscribe({
      next: (response: ObterLogResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.obterLogResponse = response;
        this.model.get('datetimeInclusao')?.setValue(response.logStruct.datetimeInclusao);
        this.model.get('funcaoOrigem')?.setValue(response.logStruct.funcaoOrigem);
        this.model.get('idEmpresa')?.setValue(response.logStruct.idEmpresa?.toString());
        this.model.get('idUsuario')?.setValue(response.logStruct.idUsuario?.toString());
        this.model.get('idLog')?.setValue(response.logStruct.idLog);
        this.model.get('projetoOrigem')?.setValue(response.logStruct.projetoOrigem);
        this.model.get('tipo')?.setValue(response.logStruct.tipo);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  openModalRevelarDadosSensiveis(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja revelar os dados sensíveis?`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.revelarDadosSensiveis(this.idLog);
        }
      },
    });
  }

  private revelarDadosSensiveis(idLog: number): void {
    this.visualizadorLogService.revelarDadosSensiveis(idLog).subscribe({
      next: (response: LogDadosSensiveisResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.dadosRevelados = false;
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.dadosRevelados = true;
        this.modelDadosSensiveis
          .get('parametroEntrada')
          ?.setValue(response.logDadosSensiveisStruct.parametroEntrada);
        this.modelDadosSensiveis.get('mensagem')?.setValue(response.logDadosSensiveisStruct.mensagem);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
        this.dadosRevelados = false;
      },
    });
  }
}
